export function H1({
  children,
  className,
  ...props
}: React.ComponentPropsWithoutRef<"h1">) {
  return (
    <h1 className={`text-4xl font-bold${className ? ` ${className}` : ""}`} {...props}>
      {children}
    </h1>
  );
}
